import { useState, type ReactNode } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography,
  Chip,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CategoryCardProps {
  title: string;
  score: number;
  status: 'pass' | 'warning' | 'fail';
  summary: string;
  details: ReactNode;
  defaultExpanded?: boolean;
  icon?: ReactNode;
}

export default function CategoryCard({
  title,
  score,
  status,
  summary,
  details,
  defaultExpanded = false,
  icon,
}: CategoryCardProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const getStatusColor = () => {
    switch (status) {
      case 'pass': return 'success';
      case 'warning': return 'warning';
      case 'fail': return 'error';
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      elevation={2}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack spacing={1} width="100%">
          <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
            <Box display="flex" alignItems="center" gap={1.5}>
              {icon}
              <Typography variant="h6" component="h3" fontWeight={600}>
                {title}
              </Typography>
            </Box>
            <Chip
              label={`${score}/100`}
              color={getStatusColor()}
              size="small"
            />
          </Box>
          <Typography variant="body2" color="text.secondary">
            {summary}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        {details}
      </AccordionDetails>
    </Accordion>
  );
}
